export type AccountDailyRow = {
  account_id: string;
  stat_date: string;
  username: string | null;
  followers_count: number | null;
  follows_count: number | null;
  media_count: number | null;
  views: number | null;
  reach: number | null;
  total_interactions: number | null;
  impressions: number | null;
  follower_delta: number | null;
};

export type ChartPoint = {
  date: string;
  followers: number;
  views: number;
  reach: number;
  interactions: number;
};

export function buildChartSeries(rows: AccountDailyRow[]): ChartPoint[] {
  return [...rows]
    .sort((a, b) => a.stat_date.localeCompare(b.stat_date))
    .map((r) => ({
      date: r.stat_date,
      followers: r.followers_count ?? 0,
      views: r.views ?? 0,
      reach: r.reach ?? 0,
      interactions: r.total_interactions ?? 0,
    }));
}
